
export default function Logout(){
    sessionStorage.clear();
    localStorage.removeItem("jwtToken")
    window.location.assign('/');
}


